// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"170":"api-test","982":"product-detail"}[chunkId] || chunkId) + "." + {"170":"1e71fd78","555":"bf6f9137","623":"c4dece82","982":"0b4aaa4e"}[chunkId] + ".css";
};